import { ConcreteEncodable } from "./ConcreteEncodable";

import { TrustTokenEncoder } from "../../encoder/TrustTokenEncoder";

import * as CubiqTS from "../../index";

export class TrustToken extends ConcreteEncodable {
  public static enType: string = "com.bcdfx.security.TrustToken";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public signature: string;
  /*FID=3*/
  public timeStamp: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = TrustTokenEncoder.Instance;
    this.setEncodableType(TrustToken.enType);
    //Model
  }

  public toString(): string {
    return (
      "TrustToken[" +
      "id=" +
      this.id +
      "signature=" +
      this.signature +
      "timeStamp=" +
      this.timeStamp +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
